export default __webpack_public_path__ + "static/media/1195.4e1b56ec.png";